import { Exclude, Expose } from 'class-transformer';
import { WorkspaceDTO } from './workspace.dto';

@Exclude()
export class SocialSetDTO {
  @Expose()
  id: number;

  @Expose()
  workspaceId: number;

  @Expose()
  workspace: WorkspaceDTO;

  @Expose()
  instagramAccountId: number;

  @Expose()
  instagramName: string;

  @Expose()
  pinterestId: string;

  @Expose()
  snipfeedId: string;

  @Expose()
  pinterestName: string;

  @Expose()
  icon: string;
}
